export default {
    hmdaEditModal: {
        isOpen: false,
    },
    hmdaExportModal: {
        isOpen: false,
    },
    hmdaManageDeletedModal: {
        isOpen: false,
    },
};
